import React, { Component } from 'react';

export class InputAlert extends Component {
  render() {
    return (
      <small
        style={ {
          display:
            this.props.validation.isInvalid && this.props.wasValidated
              ? ''
              : 'none',
        } }
        className="text-danger float-left"
      >
        {this.props.validation.message}
      </small>
    );
  }
}

export const FunInputAlert = (props) => (
  <small className="text-danger float-left">{props.children}</small>
);
